<div class="mt-2 ml-3 mr-3 pt-2">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
    <label class="font-semibold category-name" translate>protocol.lbl_protocol_users</label>
    @if(isAllowToAddProduct) {
    <p-button class="flex align-items-center justify-content-center" icon="pi pi-plus"
      [label]="'protocol.lbl_add_protocol_user' | translate" (click)="onAdd()"></p-button>
    }
  </div>
  @if(data){
  <app-mi-table
    [collectionOfColumns]="allColumns"
    [attributeLabels]="filterAttributeLabels"
    [data]="tableData"
    entityName="protocol_user"
    [isEntity]="isEntity"
    [isLoading]="isLoading"
    (onPageChange)="onPageChange($event)"
    (itemPerPageChange)="itemPerPageChange($event)"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [message]="deleteSiteMsg"
    [header]="deleteSiteHeaderMsg"
    (onDelete)="onUserDelete($event)"
    (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
    [filterList]="filterList"
    (onValueChange)="onFilterValueChange($event)"
    [filterFields]="filterFieldsArray"
    [label]="btnLabel"
    (onBtnClick)="onAdd()"
    [bulkUpdateLabel]="bulkUpdateLabel"
    [bulkDeleteLabel]="bulkDeleteLabel"
    [attributeData]="attributeData"
    (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
    (onSearchValueChange)="onSearchValueChanges($event)"
    (onUpdate)="onUpdateUser($event)"
    [rowItems]="rowItems"
    [bulkSelectionsItems]="bulkSelectionsItems"
    (setCurrentRowData)="setCurrentRowData($event)"
    [visiblePrintLabel]="visiblePrintLabel"
    [showBulkUpdateDialog]="showBulkUpdateDialog"
    (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
    [visible]="visible"
    [bulkUpdateHeader]="bulkUpdateHeader"
    [reviewHeader]="reviewHeader"
    [btnUpdate]="btnUpdate"
    (onSortData)="onSortData($event)">
  </app-mi-table>
  }
</div>

@if(showAddDialog) {
<app-add-protocol-user
  [userId]="userId"
  (closePopup)="onClosePopup($event)"
  [sponsorDetails]="sponsorDetails"
  [protocolId]="protocolId"
  [isChangeReasonNotRequired]="isChangeReasonNotRequired"
  (saveSuccess)="onSaveSuccess()">
</app-add-protocol-user>
}